export default __webpack_public_path__ + "static/media/logo.44643540.svg";